// GroupedNumericFields.tsx
import React from "react";
import { Control, FieldErrors, FieldError } from "react-hook-form";
import FormGroup from "app/components/common/inputs/FormGroup";
import InputField from "app/components/common/inputs/InputField";

interface InputConfig {
  label: string;
  name: string;
  placeholder?: string;
  tooltip?: string;
  required: boolean;
}

interface GroupedNumericFieldsProps {
  control: Control<any>;
  errors: FieldErrors<any>;
  groups: InputConfig[][];
}

const LiabilitiesInputs: React.FC<GroupedNumericFieldsProps> = ({
  control,
  errors,
  groups,
}) => {
  return (
    <>
      {groups.map((group, index) => (
        <FormGroup key={index}>
          {group.map(({ label, name, placeholder, tooltip, required }) => (
            <InputField
              key={name}
              label={label}
              name={name}
              control={control}
              type="number"
              required={required}
              placeholder={placeholder || "$0"}
              error={
                typeof (errors[name] as FieldError)?.message === "string"
                  ? (errors[name] as FieldError).message
                  : undefined
              }
              className="flex-1"
              rules={
                required
                  ? {
                      required: "Field is required",
                      min: {
                        value: 0,
                        message: "Dependents value cannot be negative",
                      },
                      validate: (value: number) =>
                        value >= 0 || "Value cannot be negative",
                    }
                  : {
                      min: {
                        value: 0,
                        message: "Dependents value cannot be negative",
                      },
                      validate: (value: number) =>
                        value >= 0 || "Value cannot be negative",
                    }
              }
              tooltip={tooltip}
            />
          ))}
        </FormGroup>
      ))}
    </>
  );
};

export default LiabilitiesInputs;
